module.exports = __webpack_public_path__ + "img/stena20.0668c19c.jpg";